import { useEffect, useState } from 'react';
import { QueryStatus } from 'src/types';
import { HttpLCLS } from '../api/httpLCLS';
import {OperacionLCLSCuentaVista} from '../types/dto';

export const useLCLSCuentaLimites = (idOperacion: number) => {
    const [cuentas, setCuentas] = useState<OperacionLCLSCuentaVista[]>();
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle);

    const fetch = () => {
        if (!idOperacion) return;

        setStatus(QueryStatus.Loading);

        HttpLCLS.getCuentas(idOperacion)
            .then(data => {
                setCuentas(data);
                setStatus(QueryStatus.Success);
            })
            .catch(error => {
                setStatus(QueryStatus.Error);
                console.error(error);
            });
    };

    const refetch = () => fetch();

    useEffect(() => {
        fetch();
    }, [idOperacion]);

    return { cuentas, refetch, status };
};